export const googleScopes = [
    // The scope parameter must begin with the openid value and then include the profile value, the email value, or both.
    "openid", 
    "profile",
    "email",
    "https://www.googleapis.com/auth/calendar",
    "https://www.googleapis.com/auth/drive",
    "https://www.googleapis.com/auth/documents",
    'https://www.googleapis.com/auth/contacts',
    'https://www.googleapis.com/auth/contacts.other.readonly',
    'https://mail.google.com/',
].join(" ");

export const missingScopes = (currentScopes) => googleScopes?.filter(scope => !currentScopes.includes(scope));